import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, Component, useRef } from "react"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"

import TableComponent from './Components/TableComponent'
import { Link } from 'react-router-dom'

const IndexView = (props) => {
    const activeRef = useRef();
    const inactiveRef = useRef();

    const reloadInactiveRef = () => inactiveRef.current.setTokenAPI()


    return (
        <Fragment>
            <Container fluid>
                <Card>
                    <CardBody>
                      
                        <CardTitle>Daftar Integrasi Mutasi Jabatan </CardTitle>
                        <CardSubtitle className="mb-3">
                        </CardSubtitle>
                        <hr/>
                        <TableComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                    </CardBody>
                </Card>
            </Container>
        </Fragment>
    )
}

export default IndexView